
// TODO:
// Allow users to click and drag to scroll when there is overflow.
// See: https://htmldom.dev/drag-to-scroll/

import { computed, defineComponent, toRefs } from "vue";
import useToolbar from "@/composables/useToolbar";

export default defineComponent({
  name: "PagePreview",
  setup() {
    const {
      global,
      current,
      dimensions,
      margins,
      grid,
      preview,
      isPassing
    } = useToolbar();
    const { rows: previewRows } = toRefs(preview);
    const { panel } = toRefs(current);

    const style = computed(() => ({
      page: `width: ${dimensions.widthPt}px; height: ${dimensions.heightPt}px;`,
      margin: `top: ${margins.topPt}px; bottom: ${margins.bottomPt}px`,
      line: `margin-top: ${global.leading - 1}px`,
      guide: `height: ${grid.rowSize}px; margin-top: ${grid.gutter}px`,
      grid: `margin-top: ${grid.gutter - 1}px`
    }));

    // TODO:
    // why arent SOME preview guide: `height: ${preview.rowSize}px` not rendering correctly?

    const previewStyle = computed(() => ({
      page: `width: ${dimensions.widthPt}px; height: ${dimensions.heightPt}px;`,
      margin: `top: ${preview.top}px; bottom: ${preview.bottom}px`,
      line: `margin-top: ${preview.leading - 1}px`,
      guide: `height: ${preview.rowSize}px; margin-top: ${preview.gutter}px;`,
      grid: `margin-top: ${preview.gutter - 1}px`
    }));

    const linesRoundedUp = computed(() => Math.ceil(margins.lines));
    const previewLinesRoundedUp = computed(() =>
      Math.ceil(
        (dimensions.heightPt - preview.top - preview.bottom) / preview.leading
      )
    );

    return {
      ...toRefs(global),
      ...toRefs(grid),
      ...toRefs(isPassing),
      panel,
      style,
      linesRoundedUp,
      previewStyle,
      previewLinesRoundedUp,
      previewRows
    };
  }
});
